/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Input = react_1.default.forwardRef(function (props, ref) {
  var className = props.className,
      id = props.id,
      inputMode = props.inputMode,
      name = props.name,
      onChange = props.onChange,
      pattern = props.pattern,
      placeholder = props.placeholder,
      style = props.style,
      value = props.value;

  var handleOnChange = function handleOnChange(e) {
    if (onChange) {
      onChange(e);
    }
  };

  return react_1.default.createElement("input", {
    className: classnames_1.default(className),
    id: id,
    inputMode: inputMode,
    name: name,
    ref: ref,
    value: value,
    onChange: function onChange(e) {
      return handleOnChange(e);
    },
    pattern: pattern,
    placeholder: placeholder,
    style: style,
    type: props.type || 'text'
  });
});
exports.default = Input;